export default __webpack_public_path__ + "static/media/IMG_1997.5d4dd22d.JPG";